// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "autocomplete-blot {\n  height: 22px;\n  padding: 0 6px;\n  background-color: #e6f3ff;\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 5px;\n  color: #0071d4;\n  display: inline-flex;\n  align-items: center;\n  cursor: default;\n}\n", ""]);
// Exports
module.exports = exports;
